import React from "react";
import { Layout, Grid } from "antd";
import { Outlet } from "react-router-dom";
import AppHeader from "./AppHeader";
import Sidebar from "./SideBar";
import { isMobile } from "react-device-detect";
const { useBreakpoint } = Grid;

const { Content } = Layout;

const DentalIndentificationLayout = () => {
  const screens = useBreakpoint(); // Returns an object with current breakpoints
  const isMobile = !screens.md;
  return (
    <Layout style={{ height: "100vh", position: "relative" }}>
      {!isMobile && <Sidebar />}
      <Layout>
        <AppHeader />
        <Content
          style={{
            padding: "20px 30px",
            height: "calc(100vh - 64px)",
            overflowY: "auto",
            background: "#F2F8FB",
            paddingBottom: "100px !important",
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default DentalIndentificationLayout;
